import { render, staticRenderFns } from "./SubmitIdeas.vue?vue&type=template&id=040a856c"
import script from "./SubmitIdeas.vue?vue&type=script&lang=js"
export * from "./SubmitIdeas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports